import React from 'react';
import PropTypes from 'prop-types';
import { compose, pure } from 'recompose';
import { withRouter } from 'react-router-dom';

import { Button, Hr } from 'components/shared';
import { FormFlex, FormBox } from 'components/shared/form';

import { APPLICATION_STEP_PATH } from 'constants/routes';
import { getPath } from 'utils';

import Fields from './Fields';
import Loader from './Loader';

const propTypes = {
  disabled: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  loading: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  signatureVersion: PropTypes.string.isRequired,
};

function Form({ disabled, handleSubmit, match, loading, submitting, signatureVersion, acknowledgmentCheckboxesVersion }) {
  const { token } = match.params;
  return (
    <form>
      {loading && <Loader />}
      {!loading && <Fields disabled={disabled} signatureVersion={signatureVersion} acknowledgmentCheckboxesVersion={acknowledgmentCheckboxesVersion} />}
      <FormFlex>
        <FormBox width={1}>
          <Hr />
        </FormBox>
      </FormFlex>
      <FormFlex alignItems="center" justifyContent="flex-start">
        <FormBox pl={3} pr={3}>
          <Button to={getPath(APPLICATION_STEP_PATH, { token, step: 4 })} transparent disabled={disabled || submitting}>
            Back
          </Button>
        </FormBox>
        <FormBox p={[3, 3, 0]} alignSelf={['flex-end', 'flex-end', 'inherit']}>
          <Button onClick={handleSubmit} dataName="buttonNext" rounded disabled={disabled || submitting}>
            {submitting ? 'Please wait…' : 'Next'}
          </Button>
        </FormBox>
      </FormFlex>
    </form>
  );
}

Form.propTypes = propTypes;

const enhance = compose(withRouter, pure);

export default enhance(Form);
